<script>
	export let specName
	export let rzadek
	export let mobile
	export let thisPage
	export let active
	export let otherModels
</script>

<div class="rzadek" class:mobile>
	<div class="specName">{specName}</div>
	
	{#if rzadek[specName].all}
		<div class="all">
			{@html rzadek[specName].all}
		</div>
	{:else}
		<div class="spec">
			{@html rzadek[specName][thisPage]}
		</div>

		{#if mobile}
			<div class="spec mobile">
				{@html rzadek[specName][active]}
			</div>
		{:else}
			{#each otherModels as otherModel}
				<div class="spec">
					{@html rzadek[specName][otherModel]}
				</div>
			{/each}
		{/if}
	{/if}
</div>

<style>
	.rzadek {
		width: 100%;
		display: flex;
		border-bottom: 1px solid var(--white);
		padding: 0.618em 0.382em;
	}

	.specName {
		font-size: 1.5em;
		font-weight: 300;
		width: 25%;
	}
	.rzadek .spec {
		width: 25%;
		padding: 0 1em;
	}
	.rzadek .all {
		width: 75%;
		padding: 0 1em;
	}
	.rzadek.mobile {
		flex-wrap: wrap;
		margin-bottom: 0.5em;
	}
	.rzadek.mobile .specName {
		width: 100%;
		border-bottom: 1px solid #d3d3d34d;
		font-weight: 600;
	}
	.rzadek.mobile .spec {
		padding: 0.5em;
		width: calc(50% - 1em)
	}
	.rzadek.mobile .all {
		padding: 0.5em;
		width: cacl(100% - 1em);
	}
	:global(.tabelka .rzadek p) {
		line-height: 1.3;
		margin-bottom: 9px;
		color: var(--gray);
		filter: brightness(69%);
	}
	:global(.tabelka .rzadek p span) {
		font-weight: 600;
		color: var(--darker);
		filter: brightness(138%);
	}
	:global(.tabelka .rzadek .big) {
	    font-size: 138%;
	    font-weight: bold;
	    color: var(--darker);
	    filter: brightness(138%);
	}
	:global(.tabelka .rzadek p.highlight) {
	    /*font-weight: bold;*/
	    color: var(--darker);
	}
</style>